namespace advisorop.components.advisor {

    export class AdvisorInvestorDashboardController{
        $router;
        investor: domains.IInvestor;
        investorId: number;
        chartData: domains.IChartDataSource[] = [{
            chart: {
                caption: "...", numberPrefix: "", subCaption: "", theme: ""
            },
            data: []
        }];       
        
        constructor(private advisorService: services.AdvisorService) {            
        }

        $onInit(): void {            
        }

        loadCharts(): void {
            this.advisorService.getIDCharts(this.investorId).then((data) => {

                //console.log(data.data);
                
                this.chartData = data.data;
            });
        };

        loadInvestor(): void {
            this.advisorService.getInvestor(this.investorId)
                .then((data) => {
                    this.investor = data.data;
                })
                .catch((reason) => {
                    console.log("Error during load of individual");
                    console.log(reason);
                });
        }

        syncInvestorWithCrm = (investorId: number) => {
            // console.log(`Sync Investor ${investorId} with CRM`);
            this.advisorService.syncInvestorWithCRM(investorId).then(() => {
                // console.log("Investor has been synced");
                this.loadInvestor();
            });

        }
        
        $routerOnActivate(next, previous) {   
            this.investorId = <number>next.params.investorId;

            this.loadInvestor();
            
            this.loadCharts();
        }        

    }



    class AdvisorInvestorDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["advisorService", AdvisorInvestorDashboardController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/views/advisor-investor-dashboard.html";            
        }
    }
    angular.module(Constants.APP).component("advisorInvestorDashboard", new AdvisorInvestorDashboard());
    
}